const { captureAttribution } = require('./src/helpers/attribution');

// Cookie-consent (CCPA opt-out): true once the visitor has chosen "Decline".
function dcConsentDenied() {
  try {
    return typeof window !== 'undefined' && window.localStorage &&
      window.localStorage.getItem('dc_cookie_consent') === 'denied';
  } catch (e) { return false; }
}

// Fired once when the app first mounts in the browser.
exports.onClientEntry = () => {
  if (typeof window === 'undefined') return;
  // Honor a stored cookie-consent decline before any tags fire.
  if (dcConsentDenied()) { window['ga-disable-AW-18295419036'] = true; }
  // Capture first-touch attribution on the very first page hit.
  captureAttribution();

  // Global delegated click listener for phone conversion tracking.
  // Catches every tel: link click anywhere on the site — no need to
  // wire individual buttons.
  //
  // 1. Fires the Google Ads "Click to call" conversion directly via
  //    the base gtag tag loaded in html.js (AW-18295419036). tel:
  //    links don't unload the page, so no event_callback/redirect
  //    dance is needed.
  // 2. Also pushes a `phone_click` event to the GTM dataLayer for
  //    GA4 reporting or any GTM-based triggers.
  document.addEventListener('click', (e) => {
    const link = e.target.closest && e.target.closest('a[href^="tel:"]');
    if (!link) return;
    if (dcConsentDenied()) return;

    // Google Ads click-to-call conversion.
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'conversion', {
        send_to: 'AW-18295419036/bTeDCPWa5s0cEJzh95NE',
        value: 1.0,
        currency: 'USD',
      });
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'phone_click',
      phone_number: link.getAttribute('href').replace(/^tel:/, ''),
      link_text: (link.textContent || '').trim().slice(0, 60),
      page_path: window.location.pathname,
    });
  }, { capture: true });
};

// Fired on every client-side route change (and on initial page load).
exports.onRouteUpdate = ({ location, prevLocation }) => {
  if (typeof window === 'undefined') return;

  // Meta Pixel PageView. The base snippet in html.js only calls fbq('init'),
  // deliberately — this site is a SPA, so a PageView fired in the base code
  // would register once (first page) and every client-side navigation after
  // that would go untracked. onRouteUpdate runs on the initial load AND on
  // every route change, so this yields exactly one PageView per page.
  if (typeof window.fbq === 'function' && !dcConsentDenied()) {
    window.fbq('track', 'PageView');
  }

  if (!window.localStorage) return;

  // Persist last-touch + first-touch UTMs / landing URL / referrer.
  // First-touch wins by default; see src/helpers/attribution.js for rules.
  captureAttribution();

  // Legacy: keep the lNdUrL / crNtPaTH / prevPaTHnAme keys around for any
  // existing code that still reads them (forms, etc.).
  if (!window.localStorage.getItem('lNdUrL')) {
    window.localStorage.setItem('lNdUrL', location.href);
    window.localStorage.setItem('lNdUrLDtIme', new Date());
  }
  window.localStorage.setItem('crNtPaTH', location.href);
  window.localStorage.setItem(
    'prevPaTHnAme',
    prevLocation ? prevLocation.href : null
  );
};